import { useState } from "react";
import { API_URL } from "../constants";
import Footer from "../Footer";
import Header from "../Header";
import axios from "axios";

const ContactUs = () => {
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const firstName = form[0].value;
    const lastName = form[1].value;
    const email = form[2].value;
    const phone = form[3].value;
    const message = form[4].value;

    axios
      .post(API_URL + "contactus/", {
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone,
        message: message,
      })
      .then(() => {
        setMessage("Successfully sent your message!");
      })
      .catch(() => {
        setMessage("Service is busy. Please, try again later.");
      });
  };

  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="contacts">
            <div className="container-fix-width">
              <div className="contacts-wrap">
                <h1 className="main-title">Contact Us</h1>
                <p>
                  If you have questions, need assistance, or want to provide
                  feedback, our team is ready to help.
                </p>
                <form onSubmit={handleSubmit} className="contacts-form form-styles">
                  <div className="form__inputs-container">
                    <div className="form-input__wrap half-width">
                      <label for="contFirstName">First Name*</label>
                      <input
                        type="text"
                        name="contFirstName"
                        id="contFirstName"
                        placeholder="Your first name"
                        required
                      />
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="contLastName">Last Name*</label>
                      <input
                        type="text"
                        name="contLastName"
                        id="contLastName"
                        placeholder="Your last name"
                        required
                      />
                    </div>
                    <div className="form-input__wrap">
                      <label for="contEmail">Email*</label>
                      <input
                        type="email"
                        name="contEmail"
                        id="contEmail"
                        placeholder="Your email address"
                        required
                      />
                    </div>
                    <div className="form-input__wrap">
                      <label for="contTel">Phone</label>
                      <input
                        type="tel"
                        name="contTel"
                        id="contTel"
                        placeholder="Your phone number"
                      />
                    </div>
                    <div className="form-input__wrap">
                      <label for="contMessage">Message*</label>
                      <textarea
                        name="contMessage"
                        id="contMessage"
                        cols="50"
                        rows="4"
                        placeholder="Your message..."
                        required
                      ></textarea>
                    </div>
                    
                    <button type="submit" className="main-btn" name="contSubmBtn">
                      Submit
                    </button>
                    <p id="contacts-message">{message}</p>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;
